
import { serverTimestamp, doc, getDoc, setDoc } from "firebase/firestore"; // Importa apenas as funções do Firestore necessárias
import { db } from './firebase'; // Importa a instância 'db' do Firestore já inicializada

/**
 * Busca um comentário da IA cacheado no banco de dados para uma dada questão.
 * @param questionId - O ID da questão a ser buscada.
 * @returns O comentário em formato de string, ou null se não for encontrado.
 */
export const fetchAiCommentFromDB = async (questionId: string): Promise<string | null> => {
  console.log(`[AICommentService] Verificando no DB por comentário para a questão: ${questionId}`);
  
  try {
    // Define o caminho para o documento do comentário da IA na coleção 'aiComments'
    // A chave do documento é o questionId para fácil acesso.
    const docRef = doc(db, 'aiComments', questionId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log(`[AICommentService] Comentário cacheado encontrado para ${questionId}.`);
      // Retorna o comentário do campo 'comment' do documento
      return docSnap.data().comment;
    }
    
    return null; // Retorna null se o documento não existir

  } catch (error) {
    console.error(`[AICommentService] Erro ao buscar comentário do DB para ${questionId}:`, error);
    return null; // Retorna null em caso de erro para não bloquear a busca na API
  }
};

/**
 * Salva um comentário da IA no banco de dados associado a uma questão.
 * @param questionId - O ID da questão.
 * @param comment - O comentário gerado pela IA.
 */
export const saveAiCommentToDB = async (questionId: string, comment: string): Promise<void> => {
  console.log(`[AICommentService] Salvando comentário para a questão ${questionId} no DB.`);
  
  try {
    // Define o caminho para o documento onde o comentário será salvo
    const docRef = doc(db, 'aiComments', questionId);
    
    // Salva o comentário junto com um timestamp de quando foi criado
    await setDoc(docRef, {
      comment: comment,
      createdAt: serverTimestamp() // Usa o timestamp do servidor para garantir precisão
    });
    console.log(`[AICommentService] Comentário salvo com sucesso no DB para ${questionId}.`);
  } catch (error) {
    console.error(`[AICommentService] Erro ao salvar comentário no DB para ${questionId}:`, error);
    // Não lançamos erro aqui para não impedir que o usuário veja o comentário via API,
    // mas o logging é importante para depuração.
  }
};
